interface SEODataProps {
  type: string;
  data: Record<string, unknown>;
}

export default function SEOData({ type, data }: SEODataProps) {
  const jsonLd = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  });

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: jsonLd }}
    />
  );
}